import { Box } from '@mui/material';

import TabBar from '@/designs-dev/device/TabBar';
import { TabBarVisibilityProvider } from '@/designs-dev/device/TabBarVisibility';
import ScreenRoot from '@/components/wrapped/ScreenRoot';
import ActionsScreen from '@/karehero-app/actions/ActionsScreen';
import {
  INTAKE_ACTIONS,
  RECIPIENT,
} from '@/karehero-app/tell-us-once/intake/content';

// The actions list as the app's own tab, which is the point of it: this is the
// other way into the review, and it only reads as a place they were already going
// if it has the tab bar under it.
//
// The same shell MainTabs gives a tab, composed here rather than mounted: MainTabs
// reads the route to know which tab it is and hands ActionsScreen the app's own
// seed, and this needs its own set of actions.
const IntakeActionsScreen = () => (
  <TabBarVisibilityProvider>
    {(navHidden) => (
      <ScreenRoot>
        <Box
          sx={{
            flex: 1,
            minHeight: 0,
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          {/* The name in the bar, and the carer's own initials: this list is
              about Margaret, and it should say so the way the profile does. */}
          <ActionsScreen
            title={RECIPIENT}
            avatarInitials='VM'
            initial={{ actions: INTAKE_ACTIONS }}
          />
        </Box>
        {/* Collapses away while a sheet or pushed page is open, as it does in
            the app. */}
        <Box
          sx={{
            maxHeight: navHidden ? 0 : 140,
            overflow: 'hidden',
            flexShrink: 0,
            transition: 'max-height 280ms ease',
          }}
        >
          <TabBar active='actions' />
        </Box>
      </ScreenRoot>
    )}
  </TabBarVisibilityProvider>
);

export default IntakeActionsScreen;
